import { gql } from '../../../../hooks'

export const GET_REPORT = gql`
  query GetReport($id: ID!) {
    i3Report(id: $id) {
    }
  }
`
